/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-03-31 15:22:21
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-07-14 15:26:37
 */

// import defaultSettings from "@/settings";
import global from "@/utils/global";

const title = global.Name || global.Name;

export default function getPageTitle(pageTitle) {
	if (pageTitle) {
		return `${pageTitle} - ${title}`;
	}
	return `${title}`;
}
